<span class="tag {{ colorClass() }} {{ andClass() }}">
  @if (hasLabelLink()) {
    <a class="label" [href]="labelLink()" [routerLink]="labelRouterLink()">{{ label() }}</a>
  } @else {
    {{ label() }}
  }

  @if (hasIcon()) {
    <i class="ms-1 fa {{ icon() }}"></i>
  }

  @if (hasActionIcon()) {
    <a class="action-icon ms-1 {{ actionIconClass() }}" (click)="actionOnClick()">
      <i class="fa {{ actionIcon() }}"></i>
    </a>
  }
</span>
